import { render } from "./ApproveParts.vue?vue&type=template&id=6e567ca2"
import script from "./ApproveParts.vue?vue&type=script&lang=js"
export * from "./ApproveParts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__